import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert
} from "@mui/material";

function DeleteConfirmDialog({ open, onClose, onConfirm, subCount }) {
  const totalCount = 1 + (subCount || 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, color: "error.main" }}>
        Delete Batch Notification
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          This action cannot be undone.
        </Alert>
        <Typography>
          This is a <strong>Main</strong> notification with{" "}
          <strong>{subCount || 0}</strong> linked sub-notification
          {(subCount || 0) !== 1 ? "s" : ""}.
        </Typography>
        <Typography sx={{ mt: 1 }}>
          Deleting this notification will permanently delete{" "}
          <strong>{totalCount}</strong> notification
          {totalCount !== 1 ? "s" : ""} in total (1 main + {subCount || 0} sub).
        </Typography>
        <Typography sx={{ mt: 2, fontWeight: 600 }}>
          Are you sure you want to proceed?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          Delete All ({totalCount})
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfirmDialog;
